import { useEffect } from "react";
import { formatNumber } from "../../../../Hooks/FormatNumber.hook";
import { WhatsappSession, WhatsappSessionAction } from "../../../../interfaces/WhatsappSessions.interfaces";
import { StyledConfirmSessionAction } from "./style";

interface ConfirmSessionActionProps {
    session: WhatsappSession;
    action: WhatsappSessionAction;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ConfirmSessionAction = ({ session, action, onConfirm, onCancel }: ConfirmSessionActionProps) => {
    const label = formatNumber(session.phone || session.number);
    const isLogout = action === "LOGOUT";

    useEffect(() => {
        const closeOnEscape = (event: KeyboardEvent) => event.key === "Escape" && onCancel();

        window.addEventListener("keydown", closeOnEscape);
        return () => window.removeEventListener("keydown", closeOnEscape);
    }, [onCancel]);

    return (
        <StyledConfirmSessionAction role="dialog" aria-modal="true" aria-labelledby="confirm-session-action-title">
            <h2 id="confirm-session-action-title">
                {isLogout ? `Desvincular o número ${label}?` : `Reiniciar a sessão do número ${label}?`}
            </h2>

            {isLogout ? (
                <ul>
                    <li>O aparelho sai da lista de dispositivos conectados do celular e a sessão salva é apagada.</li>
                    <li>Ninguém recebe ou envia mensagens por este número até alguém ler o novo QR code.</li>
                    <li>O QR code novo aparece nesta tela em alguns segundos.</li>
                </ul>
            ) : (
                <p>
                    A conexão com o WhatsApp é fechada e aberta de novo com a sessão salva, sem precisar ler
                    QR code. Mensagens que chegarem nesse intervalo são entregues quando a conexão voltar.
                </p>
            )}

            <footer>
                <button type="button" onClick={onCancel} autoFocus={isLogout}>
                    Cancelar
                </button>
                <button type="button" className={isLogout ? "confirm danger" : "confirm"} onClick={onConfirm} autoFocus={!isLogout}>
                    {isLogout ? "Desvincular e gerar QR code" : "Reiniciar sessão"}
                </button>
            </footer>
        </StyledConfirmSessionAction>
    );
};
